const TABS = [
        {
            value: '2',
            label: '试题'
        },
        {
            value: '1',
            label: '试卷'
        }
]

export {
    TABS
}